import { render, staticRenderFns } from "./ActivityFormModal.vue?vue&type=template&id=54fa87eb&scoped=true"
import script from "./ActivityFormModal.vue?vue&type=script&lang=js"
export * from "./ActivityFormModal.vue?vue&type=script&lang=js"
import style0 from "./ActivityFormModal.vue?vue&type=style&index=0&id=54fa87eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa87eb",
  null
  
)

export default component.exports